import services from '../services'

export const GetPages = ({ commit }, params) => {
  commit('SET_LOADING', true)
  return services.list(params)
    .then(response => {
      commit('SET_PAGES', response.data)
      commit('SET_LOADING', false)
      return response.data
    })
    .catch(error => {
      commit('SET_LOADING', false)
      throw error
    })
}

export const GetActivePages = ({ commit }) => {
  return services.listActive()
    .then(response => {
      commit('SET_ACTIVE_PAGES', response.data)
      return response.data
    })
}

export const GetDefaultPage = ({ commit }) => {
  return services.getDefault()
    .then(response => {
      commit('SET_DEFAULT_PAGE', response.data)
      return response.data
    })
}

export const GetPage = ({ commit }, id) => {
  commit('SET_LOADING', true)
  return services.show(id)
    .then(response => {
      commit('SET_CURRENT_PAGE', response.data)
      commit('SET_LOADING', false)
      return response.data
    })
    .catch(error => {
      commit('SET_LOADING', false)
      throw error
    })
}

export const CreatePage = ({ commit }, data) => {
  commit('SET_LOADING', true)
  return services.create(data)
    .then(response => {
      commit('ADD_PAGE', response.data)
      commit('SET_LOADING', false)
      return response.data
    })
    .catch(error => {
      commit('SET_LOADING', false)
      throw error
    })
}

export const UpdatePage = ({ commit }, { id, data }) => {
  commit('SET_LOADING', true)
  return services.update(id, data)
    .then(response => {
      commit('UPDATE_PAGE', response.data)
      commit('SET_LOADING', false)
      return response.data
    })
    .catch(error => {
      commit('SET_LOADING', false)
      throw error
    })
}

export const DeletePage = ({ commit }, id) => {
  commit('SET_LOADING', true)
  return services.delete(id)
    .then(response => {
      commit('REMOVE_PAGE', id)
      commit('SET_LOADING', false)
      return response.data
    })
    .catch(error => {
      commit('SET_LOADING', false)
      throw error
    })
}

export const ChangeStatus = ({ commit }, id) => {
  return services.changeStatus(id)
    .then(response => {
      commit('UPDATE_PAGE', response.data.page)
      return response.data
    })
}

export const SetAsDefault = ({ commit }, id) => {
  return services.setAsDefault(id)
    .then(response => {
      commit('SET_DEFAULT_PAGE', response.data.page)
      return response.data
    })
}
